import { api } from "./useApi";

export const mercadoPagoApi = () => ({
    verificarAutenticacao: async () => {
        const response = await api.post("mercado_pago/verificar_autenticacao");
        return response.data;
    },
});
